import React from "react";
import {Box, Typography, Grid, Skeleton, Stack} from "@mui/material";
import {Card} from "react-bootstrap";

export const DatePickerSuspense = () => {
    return (
        <Card style={{width:'350px'}}>
            <Card.Body>
                <Typography variant="h6" gutterBottom>
                    <Skeleton width="40%"/>
                </Typography>

                <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
                    <Skeleton variant="circular" width={30} height={30}/>
                    <Skeleton width="60%" height={30}/>
                    <Skeleton variant="circular" width={30} height={30}/>
                </Stack>

                <Box mt={2}>
                    <Grid container spacing={1}>
                        {Array.from({length: 7}).map((_, index) => (
                            <Grid item xs={1.7} key={index}>
                                <Skeleton width="100%" height={25}/>
                            </Grid>
                        ))}
                    </Grid>
                    <Grid container spacing={1} mt={1}>
                        {Array.from({length: 35}).map((_, index) => (
                            <Grid item xs={1.7} key={index}>
                                <Skeleton variant="rectangular" width="100%" height={30}/>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </Card.Body>
        </Card>
    );
}
